import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  textAreaContainer: {
    position: 'relative',
    boxSizing: 'border-box',
    boxShadow: 'none',
    border: '1px solid',
    borderRadius: '16px',
    borderColor: theme.palette.focus90.main,
    '&:focus-within': {
      borderColor: theme.palette.peace40.main
    }
  },
  textArea: {
    ...theme.typography.body_smallRegular,
    fontFamily: ['Inter', 'sans-serif'].join(','),
    color: theme.palette.focus90.main,
    padding: '0 1rem',
    margin: '2rem 0 1.2rem 0',
    height: '120px',
    width: '100%',
    outline: 'none',
    border: 'none',
    resize: 'none',
    [theme.breakpoints.down('sm')]: {
      ...theme.typography.body_largeRegular,
      height: '160px'
    },
    '&:focus ~ $label': {
      ...theme.typography.caption_smallRegular,
      color: theme.palette.focus90.main,
      top: '1rem',
      left: '1rem'
    },
    '&:valid ~ $label': {
      ...theme.typography.caption_smallRegular,
      color: theme.palette.focus90.main,
      top: '1rem',
      left: '1rem'
    },
    '&:focus ~ $counter': {
      ...theme.typography.caption_smallRegular,
      color: theme.palette.focus90.main,
      bottom: '0.5rem',
      right: '0.5rem'
    },
    '&:valid ~ $counter': {
      ...theme.typography.caption_smallRegular,
      color: theme.palette.focus90.main,
      bottom: '0.5rem',
      right: '0.5rem'
    }
  },
  label: {
    ...theme.typography.body_smallRegular,
    color: theme.palette.focus40.main,
    position: 'absolute',
    top: '1rem',
    left: '1rem',
    pointerEvents: 'none',
    transition: '0.2s ease all',
    [theme.breakpoints.down('sm')]: {
      ...theme.typography.body_largeRegular
    }
  },
  counter: {
    ...theme.typography.body_smallRegular,
    color: theme.palette.focus40.main,
    position: 'absolute',
    bottom: '0.5rem',
    right: '0.5rem',
    pointerEvents: 'none',
    transition: '0.2s ease all',
    [theme.breakpoints.down('sm')]: {
      ...theme.typography.body_largeRegular
    }
  }
}));
